export const GATEKEEPER_ADDRESS = process.env.REACT_APP_GATEKEEPER_ADDRESS;
export const CLAIM_ISSUER = process.env.REACT_APP_CLAIM_ISSUER;
export const CLIENT_ADDRESS = process.env.REACT_APP_CLIENT_ADDRESS;

export const NO_IDENTITY = "0x0000000000000000000000000000000000000000";

export const CHAIN_NAME = process.env.REACT_APP_CHAIN_NAME ?? "";
export const CHAIN_ID: number = parseInt(process.env.REACT_APP_CHAIN_ID ?? "");
